<ng-container *ngIf="!hasOtherConnection">
    <video id="patient-video" #patientVideo autoplay playsinline></video>
    <video id="doc-video" #docVideo autoplay playsinline></video>
</ng-container>
<div class="text-center" *ngIf="hasOtherConnection">
        <h2>
            Posiadasz inne aktywne połączenie. Zamknij pozostałe okna i odśwież okno, aby ponowić próbę połączenia.
        </h2>
</div>